// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#guide {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  margin-bottom: -4vh;
  overflow: hidden;
  width: 100%;
}

#guide .chat::before {
  content: '';
  display: block;
  margin-top: auto;
}

#guide .text-input {
  margin: 0 7.5%;
}

#comment-container .popup {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/guide/Guide.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb","sourcesContent":["#guide {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  margin-bottom: -4vh;\n  overflow: hidden;\n  width: 100%;\n}\n\n#guide .chat::before {\n  content: '';\n  display: block;\n  margin-top: auto;\n}\n\n#guide .text-input {\n  margin: 0 7.5%;\n}\n\n#comment-container .popup {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
